// removed by extract-text-webpack-plugin
module.exports = {"progress":"_cjH8gPWVY3Gh8rHo5_5S","spin":"_2DosPFftMSSg2kTVSVAcxi"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Loading/style.css
// module id = 386
// module chunks = 38